import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';
import { map, defer, debounce } from 'lodash/fp';
import moment from 'moment';
import classnames from 'classnames';

import styles from './doctorAppointment.module.css';
import { ReactComponent as Arrow } from '../../../../svgs/leftarrow.svg';
import NextAvailableSlot from '../../NextAvailableSlot/index';
import { SelectedTimePropType, SlotPropType } from '../../propTypes/index';

class DoctorAppointment extends Component {
  static propTypes = {
    appointmentSlots: PropTypes.arrayOf(SlotPropType).isRequired,
    doctorId: PropTypes.string.isRequired,
    selectedTime: SelectedTimePropType,
    setTime: PropTypes.func.isRequired,
    nextAvailableSlot: PropTypes.string,
    goToDate: PropTypes.func.isRequired,
    sessionId: PropTypes.string,
    morning: PropTypes.bool,
    afternoon: PropTypes.bool,
    evening: PropTypes.bool,
    currentFilter: PropTypes.string,
    filterMorning: PropTypes.func,
    filterAfternoon: PropTypes.func,
    filterEvening: PropTypes.func,
  };
  state = {
    right: false,
    left: false,
  };
  componentDidMount() {
    defer(this.onScroll);
  }
  UNSAFE_componentWillReceiveProps() {
    if (this.container.children[0]) {
      this.container.scrollLeft = 0;
    }
    defer(this.onScroll);
  }
  onScroll = () => {
    if (this.container) {
      this.setState({
        right: this.checkRightScroll(),
        left: this.checkLeftScroll(),
      });
    }
  };
  checkLeftScroll = () => this.container && this.container.scrollLeft > 5;
  checkRightScroll = () =>
    // eslint-disable-next-line max-len
    this.container &&
    this.container.scrollWidth -
      (this.container.scrollLeft + this.container.offsetWidth) >
      5;
  createSlot = (
    time,
    selectedTime,
    doctorId,
    appointmentId,
    setTime,
    sessionId,
  ) => {
    const selected =
      doctorId === selectedTime.doctorId &&
      time === selectedTime.time &&
      appointmentId === selectedTime.appointmentId;
    return (
      <button
        key={time}
        id="nw_slot"
        className={classnames(styles.item, { [styles.selected]: selected })}
        onClick={() => setTime(doctorId, appointmentId, time, sessionId)}
      >
        {moment(time).format('h:mm')}
      </button>
    );
  };
  scrollContainer = (goRight, distance) => {
    const speed = 3;
    const stopPoint = goRight
      ? this.container.scrollLeft + distance
      : this.container.scrollLeft - distance;
    const shouldKeepScrolling = goRight
      ? this.checkRightScroll
      : this.checkLeftScroll;
    const hasReachedStopPoint = () =>
      goRight
        ? this.container.scrollLeft >= stopPoint
        : this.container.scrollLeft <= stopPoint;
    const intervalId = setInterval(() => {
      if (goRight) {
        this.container.scrollLeft += 1;
      } else {
        this.container.scrollLeft -= 1;
      }
      if (hasReachedStopPoint() || !shouldKeepScrolling()) {
        clearInterval(intervalId);
      }
    }, speed);
  };
  scrollRight = () => {
    this.scrollContainer(true, 100);
  };
  scrollLeft = () => {
    this.scrollContainer(false, 100);
  };
  render() {
    return (
      <EventListener target="window" onResize={debounce(250, this.onScroll)}>
        <div className={styles.container}>
          {this.state.left && (
            <div
              onClick={this.scrollLeft}
              className={styles.arrowContainerLeft}
            >
              <Arrow className={styles.left} />
            </div>
          )}
          <div
            className={styles.inner}
            onScroll={debounce(250, this.onScroll)}
            ref={c => {
              this.container = c;
            }}
          >
            {(() => {
              if (this.props.appointmentSlots.length) {
                return map(slot =>
                  this.createSlot(
                    slot.Time,
                    this.props.selectedTime,
                    this.props.doctorId,
                    slot.Guid,
                    this.props.setTime,
                    this.props.sessionId,
                  ),
                )(this.props.appointmentSlots);
              } else if (!this.props.nextAvailableSlot) {
                return <div className={styles.notAvailable}>N/A</div>;
              }
              return (
                <NextAvailableSlot
                  nextAvailableDate={this.props.nextAvailableSlot}
                  onClickAction={this.props.goToDate(
                    this.props.nextAvailableSlot,
                  )}
                />
              );
            })()}
            {this.props.morning &&
              this.props.currentFilter !== 'morning' && (
                <button
                  className={classnames(styles.item, {
                    [styles.selected]: true,
                  })}
                  style={{
                    margin: '0rem 1rem',
                    minWidth: '100px',
                    color: '#07a3c8',
                  }}
                  onClick={() => this.props.filterMorning()}
                >
                  Morning Slots
                </button>
              )}
            {this.props.afternoon &&
              this.props.currentFilter !== 'afternoon' && (
                <button
                  className={classnames(styles.item, {
                    [styles.selected]: true,
                  })}
                  style={{
                    margin: '0rem 1rem',
                    minWidth: '100px',
                    color: '#07a3c8',
                  }}
                  onClick={() => this.props.filterAfternoon()}
                >
                  Afternoon Slots
                </button>
              )}
            {this.props.evening &&
              this.props.currentFilter !== 'evening' && (
                <button
                  className={classnames(styles.item, {
                    [styles.selected]: true,
                  })}
                  style={{
                    margin: '0rem 1rem',
                    minWidth: '100px',
                    color: '#07a3c8',
                  }}
                  onClick={() => this.props.filterEvening()}
                >
                  Evening Slots
                </button>
              )}
          </div>
          {this.state.right && (
            <div
              onClick={this.scrollRight}
              className={styles.arrowContainerRight}
            >
              <Arrow className={styles.right} />
            </div>
          )}
        </div>
      </EventListener>
    );
  }
}

export default DoctorAppointment;
